import { createContext } from "react";
export const AuthStateContext = createContext({ checked: false, authenticated: false });
